import { render, staticRenderFns } from "./UserDataVerificationEsign.vue?vue&type=template&id=aec436a6&"
import script from "./UserDataVerificationEsign.vue?vue&type=script&lang=js&"
export * from "./UserDataVerificationEsign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aec436a6')) {
      api.createRecord('aec436a6', component.options)
    } else {
      api.reload('aec436a6', component.options)
    }
    module.hot.accept("./UserDataVerificationEsign.vue?vue&type=template&id=aec436a6&", function () {
      api.rerender('aec436a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/advanced/eSign/UserDataVerificationEsign.vue"
export default component.exports